// import React from 'react'

// const RockkpayTandC = () => {
//   return (
//     <div>RockkpayTandC</div>
//   )
// }

// export default RockkpayTandC

// import { Container } from '@mui/material';
// import React from 'react';
// import HeaderTwo from './HeaderTwo';
// import FooterTwo from './FooterTwo';

// const RockkpayTandC = () => {
//   return (
//   <>
//     <HeaderTwo/>
//     <Container className="terms-container max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
//       <h1 className="text-3xl font-bold text-center mb-8 text-blue-800">ROCKKPAY - TERMS AND CONDITIONS</h1>
      
//       <div className="company-info mb-8 text-center p-4 bg-gray-50 rounded-lg">
//         <h2 className="text-xl font-semibold mb-2">PAYSTREAM TECHNOLOGY PRIVATE LIMITED</h2>
//         <p>Unit No.355, Plot No 4</p>
//         <p>Registration Number: 07AAOCP7610E1ZD</p>
//       </div>
      
//       <div className="terms-content space-y-6">
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">1. ACCEPTANCE OF TERMS</h2>
//           <p>
//             Welcome to RockkPay, a digital payment solution offered by PAYSTREAM TECHNOLOGY PRIVATE LIMITED ("Company", "we", "us", or "our"). 
//             By accessing or using the RockkPay application, website, or services (collectively, the "Service"), you agree to be bound 
//             by these Terms and Conditions ("Terms"). If you do not agree to these Terms, please do not use the Service.
//           </p>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">2. DEFINITIONS</h2>
//           <ul className="list-disc pl-6 space-y-2">
//             <li><strong>"User"</strong> refers to any individual or entity that accesses or uses the RockkPay Service.</li>
//             <li><strong>"Account"</strong> means a registered account created by a User on the RockkPay platform.</li>
//             <li><strong>"Transaction"</strong> refers to any payment, transfer, or financial activity conducted through the RockkPay platform.</li>
//             <li><strong>"Merchant"</strong> refers to any business or individual that accepts payments through RockkPay.</li>
//             <li><strong>"KYC"</strong> refers to Know Your Customer verification procedures required by regulatory authorities.</li>
//           </ul>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">3. SERVICE DESCRIPTION</h2>
//           <p>
//             RockkPay is a digital payment platform that enables Users to make and receive payments, transfer funds, 
//             and access various financial services. The Service may include, but is not limited to:
//           </p>
//           <ul className="list-disc pl-6 space-y-2 mt-2">
//             <li>Peer-to-peer money transfers</li>
//             <li>Bill payments</li>
//             <li>Merchant payment processing</li>
//             <li>Digital wallet services</li>
//             <li>Recharge and utility payment services</li>
//             <li>Financial management tools</li>
//           </ul>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">4. ELIGIBILITY AND REGISTRATION</h2>
//           <p>
//             To use RockkPay, you must:
//           </p>
//           <ul className="list-disc pl-6 space-y-2 mt-2">
//             <li>Be at least 18 years of age</li>
//             <li>Be a resident of India with a valid address</li>
//             <li>Possess a valid mobile number and email address</li>
//             <li>Provide accurate and complete information during registration</li>
//             <li>Complete all required KYC verification processes</li>
//             <li>Comply with all applicable laws and regulations</li>
//           </ul>
//           <p className="mt-2">
//             We reserve the right to refuse service, terminate accounts, or cancel transactions at our discretion.
//           </p>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">5. USER ACCOUNTS AND SECURITY</h2>
//           <p>
//             Users are responsible for:
//           </p>
//           <ul className="list-disc pl-6 space-y-2 mt-2">
//             <li>Maintaining the confidentiality of their account credentials</li>
//             <li>All activities that occur under their account</li>
//             <li>Ensuring their device security while using RockkPay</li>
//             <li>Notifying us immediately of any unauthorized use or security breach</li>
//           </ul>
//           <p className="mt-2">
//             The Company is not liable for any loss or damage arising from a User's failure to comply with these security obligations.
//           </p>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">6. FEES AND CHARGES</h2>
//           <p>
//             RockkPay may charge fees for certain transactions or services. All applicable fees will be clearly 
//             disclosed before the completion of any transaction. Fees may include:
//           </p>
//           <ul className="list-disc pl-6 space-y-2 mt-2">
//             <li>Transaction processing fees</li>
//             <li>Currency conversion fees</li>
//             <li>Service charges for specific features</li>
//             <li>Merchant processing fees</li>
//             <li>Premium service subscription fees</li>
//           </ul>
//           <p className="mt-2">
//             The Company reserves the right to modify fees at any time with reasonable notice to Users.
//           </p>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">7. TRANSACTION LIMITS</h2>
//           <p>
//             RockkPay imposes transaction limits in accordance with regulatory requirements and for security purposes. 
//             These limits may vary based on:
//           </p>
//           <ul className="list-disc pl-6 space-y-2 mt-2">
//             <li>User's verification level</li>
//             <li>Account history and standing</li>
//             <li>Type of transaction</li>
//             <li>Regulatory requirements</li>
//           </ul>
//           <p className="mt-2">
//             Limits may be adjusted at the Company's discretion or as required by applicable regulations.
//           </p>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">8. PROHIBITED ACTIVITIES</h2>
//           <p>
//             Users must not use RockkPay for:
//           </p>
//           <ul className="list-disc pl-6 space-y-2 mt-2">
//             <li>Any illegal activities or violation of laws</li>
//             <li>Money laundering or terrorist financing</li>
//             <li>Fraudulent transactions or scams</li>
//             <li>Unauthorized commercial communications</li>
//             <li>Transactions involving prohibited goods or services</li>
//             <li>Harassment, defamation, or threatening behavior</li>
//             <li>Any activity that may damage, disable, or impair the functionality of RockkPay</li>
//           </ul>
//           <p className="mt-2">
//             Violation of these prohibitions may result in immediate termination of access to the Service, legal action, 
//             and reporting to appropriate authorities.
//           </p>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">9. PRIVACY AND DATA PROTECTION</h2>
//           <p>
//             Your privacy is important to us. Our collection, use, storage, and protection of your personal information 
//             is governed by our Privacy Policy, which is incorporated into these Terms by reference. By using RockkPay, 
//             you consent to our data practices as described in the Privacy Policy.
//           </p>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">10. INTELLECTUAL PROPERTY RIGHTS</h2>
//           <p>
//             All content, features, and functionality of RockkPay, including but not limited to text, graphics, logos, 
//             icons, images, audio clips, and software, are the exclusive property of PAYSTREAM TECHNOLOGY PRIVATE LIMITED and 
//             are protected by Indian and international copyright, trademark, and other intellectual property laws.
//           </p>
//           <p className="mt-2">
//             Users may not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, 
//             republish, download, store, or transmit any materials from RockkPay without prior written consent from the Company.
//           </p>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">11. REFUNDS AND CANCELLATIONS</h2>
//           <p>
//             Once initiated, most transactions on RockkPay are instantaneous and cannot be reversed. However:
//           </p>
//           <ul className="list-disc pl-6 space-y-2 mt-2">
//             <li>For merchant transactions, refund policies are determined by the respective merchant</li>
//             <li>For errors or unauthorized transactions, contact our customer support immediately</li>
//             <li>Transaction disputes must be reported within 7 days of the transaction</li>
//           </ul>
//           <p className="mt-2">
//             The Company will investigate all reported issues and take appropriate action in accordance with applicable regulations.
//           </p>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">12. LIABILITY LIMITATIONS</h2>
//           <p>
//             To the maximum extent permitted by law, PAYSTREAM TECHNOLOGY PRIVATE LIMITED shall not be liable for:
//           </p>
//           <ul className="list-disc pl-6 space-y-2 mt-2">
//             <li>Any indirect, incidental, special, consequential, or punitive damages</li>
//             <li>Loss of profits, data, use, goodwill, or other intangible losses</li>
//             <li>Damages resulting from unauthorized access to or alteration of your transmissions or data</li>
//             <li>Service interruptions or failures</li>
//             <li>Damages resulting from third-party services integrated with RockkPay</li>
//             <li>Any matter beyond our reasonable control</li>
//           </ul>
//           <p className="mt-2">
//             Our liability is limited to the amount of fees we have earned from your use of the Service during the three-month 
//             period immediately preceding the event giving rise to the claim.
//           </p>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">13. INDEMNIFICATION</h2>
//           <p>
//             You agree to indemnify, defend, and hold harmless PAYSTREAM TECHNOLOGY PRIVATE LIMITED and its officers, directors, 
//             employees, agents, licensors, and service providers from and against any claims, liabilities, damages, judgments, 
//             losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to:
//           </p>
//           <ul className="list-disc pl-6 space-y-2 mt-2">
//             <li>Your violation of these Terms</li>
//             <li>Your improper use of the Service</li>
//             <li>Your violation of any rights of a third party</li>
//             <li>Your violation of any applicable laws, rules, or regulations</li>
//           </ul>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">14. TERMINATION</h2>
//           <p>
//             The Company may terminate or suspend your account and access to RockkPay at any time, without prior notice or 
//             liability, for any reason, including but not limited to:
//           </p>
//           <ul className="list-disc pl-6 space-y-2 mt-2">
//             <li>Violation of these Terms</li>
//             <li>Suspected fraudulent or illegal activity</li>
//             <li>Extended periods of inactivity</li>
//             <li>Regulatory requirements</li>
//           </ul>
//           <p className="mt-2">
//             Upon termination, your right to use the Service will immediately cease. All provisions of these Terms that by 
//             their nature should survive termination shall survive, including ownership provisions, warranty disclaimers, 
//             indemnity, and limitations of liability.
//           </p>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">15. GOVERNING LAW AND DISPUTE RESOLUTION</h2>
//           <p>
//             These Terms shall be governed by and construed in accordance with the laws of India, without regard to its 
//             conflict of law provisions. Any disputes arising out of or relating to these Terms or the Service shall be 
//             subject to the exclusive jurisdiction of the courts in Delhi, India.
//           </p>
//           <p className="mt-2">
//             Before initiating any legal proceedings, Users agree to attempt to resolve any disputes through informal mediation. 
//             If a dispute cannot be resolved informally, either party may proceed with formal legal proceedings.
//           </p>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">16. MODIFICATIONS TO TERMS</h2>
//           <p>
//             The Company reserves the right to modify these Terms at any time. We will provide notice of significant changes 
//             through the Service or by other means. Your continued use of RockkPay after such modifications constitutes your 
//             acceptance of the revised Terms. It is your responsibility to review these Terms periodically.
//           </p>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">17. COMPLIANCE WITH REGULATORY REQUIREMENTS</h2>
//           <p>
//             RockkPay operates in compliance with all applicable regulations, including but not limited to:
//           </p>
//           <ul className="list-disc pl-6 space-y-2 mt-2">
//             <li>Reserve Bank of India (RBI) guidelines</li>
//             <li>Prevention of Money Laundering Act (PMLA)</li>
//             <li>Information Technology Act</li>
//             <li>Consumer Protection Act</li>
//             <li>Payment and Settlement Systems Act</li>
//           </ul>
//           <p className="mt-2">
//             Users must cooperate with any regulatory requirements, including KYC procedures and transaction monitoring.
//           </p>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">18. CONTACT INFORMATION</h2>
//           <p>
//             If you have any questions or concerns about these Terms or the Service, please contact us at:
//           </p>
//           <div className="contact-info mt-2 p-4 bg-gray-50 rounded-lg">
//             <p><strong>PAYSTREAM TECHNOLOGY PRIVATE LIMITED</strong></p>
//             <p>Unit No.355, Plot No 4</p>
//             <p>Email: support@rockkpay.com</p>
//             <p>Customer Support: [Your Customer Support Number]</p>
//           </div>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">19. SEVERABILITY</h2>
//           <p>
//             If any provision of these Terms is found to be unenforceable or invalid, that provision will be limited or 
//             eliminated to the minimum extent necessary, and the remaining provisions of these Terms will remain in full force and effect.
//           </p>
//         </section>
        
//         <section className="mb-6">
//           <h2 className="text-xl font-bold mb-3">20. ENTIRE AGREEMENT</h2>
//           <p>
//             These Terms, together with the Privacy Policy and any other legal notices published by the Company, constitute 
//             the entire agreement between you and PAYSTREAM TECHNOLOGY PRIVATE LIMITED regarding RockkPay and supersede all prior 
//             agreements and understandings.
//           </p>
//         </section>
//       </div>
      
//       <div className="terms-footer mt-10 text-center border-t pt-6">
//         <p className="text-gray-600">Last Updated: March 22, 2025</p>
//         <p className="text-gray-600 mt-2">© 2025 PAYSTREAM TECHNOLOGY PRIVATE LIMITED. All Rights Reserved.</p>
//       </div>
//     </Container>
    // <FooterTwo/>
    // </>
//   );
// };

// export default RockkpayTandC;


import React from 'react';
import { 
  Box, 
  Typography, 
  Container, 
  Divider, 
  Paper, 
  List, 
  ListItem, 
  ListItemText,
  ListItemIcon,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GavelIcon from '@mui/icons-material/Gavel';
import SecurityIcon from '@mui/icons-material/Security';
import PaymentIcon from '@mui/icons-material/Payment';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import InfoIcon from '@mui/icons-material/Info';
import HeaderTwo from './HeaderTwo';
import FooterTwo from './FooterTwo';

const RockkpayTandC = () => {
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <>
   
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        {/* Header Section */}
        <Box textAlign="center" mb={4}>
          <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
            RockkPay Terms and Conditions
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            PAYSTREAM TECHNOLOGY PRIVATE LIMITED
          </Typography>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Registration Number: 07AAOCP7610E1ZD
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Last Updated: {currentDate}
          </Typography>
        </Box>

        <Divider sx={{ mb: 4 }} />

        {/* Introduction */}
        <Box mb={4}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'medium', color: '#1976d2' }}>
            <GavelIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
            Introduction
          </Typography>
          <Typography variant="body1" paragraph>
            Welcome to RockkPay, a digital payment solution provided by PAYSTREAM TECHNOLOGY PRIVATE LIMITED ("Company", "we", "us", or "our"). 
            These Terms and Conditions ("Terms") govern your access to and use of the RockkPay platform, including our website, mobile 
            applications, APIs, and payment services (collectively, the "Services").
          </Typography>
          <Typography variant="body1" paragraph>
            By accessing or using RockkPay, you agree to be bound by these Terms. If you disagree with any part of the Terms, you may not 
            access or use our Services. These Terms constitute a legally binding agreement between you and PAYSTREAM TECHNOLOGY PRIVATE LIMITED.
          </Typography>
        </Box>

        {/* Terms Sections as Accordions */}
        <Box mb={4}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'medium', mb: 2, color: '#1976d2' }}>
            Key Terms and Conditions
          </Typography>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center' }}>
                <InfoIcon sx={{ mr: 1 }} /> Definitions
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <List>
                <ListItem>
                  <ListItemText 
                    primary="'Account'" 
                    secondary="Means the account created by you on the RockkPay platform to access and use our Services."
                  />
                </ListItem>
                <ListItem>
                  <ListItemText 
                    primary="'User', 'you', or 'your'" 
                    secondary="Refers to individuals, merchants, or entities that use the RockkPay Services."
                  />
                </ListItem>
                <ListItem>
                  <ListItemText 
                    primary="'Transaction'" 
                    secondary="Means any payment, fund transfer, or financial operation conducted through the RockkPay platform."
                  />
                </ListItem>
                <ListItem>
                  <ListItemText 
                    primary="'KYC'" 
                    secondary="Refers to 'Know Your Customer' verification procedures required by regulatory authorities."
                  />
                </ListItem>
              </List>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center' }}>
                <PaymentIcon sx={{ mr: 1 }} /> Payment Services
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" paragraph>
                RockkPay offers a range of payment services designed to facilitate secure and efficient digital transactions. Our platform 
                supports various payment methods including but not limited to UPI, credit/debit cards, net banking, and wallet transfers.
              </Typography>
              <Typography variant="body1" paragraph>
                All transactions processed through RockkPay are subject to verification and may be delayed or rejected if suspicious activity 
                is detected. We reserve the right to hold funds or suspend transactions pending investigation.
              </Typography>
              <Typography variant="body1" paragraph>
                Transaction fees and charges will be clearly communicated before the completion of any transaction. These fees may vary based 
                on the payment method, transaction value, and other factors as determined by the Company.
              </Typography>
              <Typography variant="body1">
                Users must ensure that sufficient funds are available to complete any transaction. Failed transactions due to insufficient 
                funds may attract penalties or charges as per applicable regulations.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center' }}>
                <SecurityIcon sx={{ mr: 1 }} /> User Responsibilities
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" paragraph>
                You are responsible for maintaining the confidentiality of your RockkPay account credentials and for all activities that occur 
                under your account. You agree to notify us immediately of any unauthorized use of your account or any other breach of security.
              </Typography>
              <Typography variant="body1" paragraph>
                As a user of RockkPay, you agree to:
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <InfoIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Provide accurate, current, and complete information during the registration process and keep your information updated." />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <InfoIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Use the Services only for lawful purposes and in accordance with these Terms." />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <InfoIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Comply with all applicable laws, regulations, and tax obligations in your jurisdiction." />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <InfoIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Not attempt to circumvent any security measures or features of the RockkPay platform." />
                </ListItem>
              </List>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center' }}>
                <PrivacyTipIcon sx={{ mr: 1 }} /> Privacy and Data Protection
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" paragraph>
                Your privacy is important to us. Our Privacy Policy outlines how we collect, use, store, and protect your personal information. 
                By using RockkPay, you consent to the data practices described in our Privacy Policy.
              </Typography>
              <Typography variant="body1" paragraph>
                We implement appropriate technical and organizational measures to protect your personal data against unauthorized or unlawful 
                processing, accidental loss, destruction, or damage.
              </Typography>
              <Typography variant="body1" paragraph>
                We may share your information with third parties as necessary to provide our Services, comply with legal obligations, protect 
                our rights, or prevent fraud. We will not sell your personal information to third parties for marketing purposes.
              </Typography>
              <Typography variant="body1">
                You have the right to access, correct, and delete your personal information held by us, subject to certain limitations as 
                permitted by applicable law.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center' }}>
                <GavelIcon sx={{ mr: 1 }} /> Limitation of Liability
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" paragraph>
                To the maximum extent permitted by applicable law, PAYSTREAM TECHNOLOGY PRIVATE LIMITED and its officers, directors, employees, 
                and agents shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including lost 
                profits, arising out of or in connection with your use of the RockkPay Services.
              </Typography>
              <Typography variant="body1" paragraph>
                Our total liability for all claims related to the RockkPay Services shall not exceed the greater of the amount paid by you 
                for the Services during the three (3) months preceding the event giving rise to the liability or INR 10,000.
              </Typography>
              <Typography variant="body1">
                These limitations will apply even if we have been advised of the possibility of such damages and notwithstanding any failure 
                of essential purpose of any limited remedy.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center' }}>
                <GavelIcon sx={{ mr: 1 }} /> Dispute Resolution
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" paragraph>
                Any dispute arising out of or in connection with these Terms shall be resolved through amicable negotiations between the parties. 
                If the dispute cannot be resolved through negotiation within thirty (30) days, it shall be referred to arbitration in accordance 
                with the Arbitration and Conciliation Act, 1996.
              </Typography>
              <Typography variant="body1" paragraph>
                The arbitration shall be conducted by a sole arbitrator appointed by PAYSTREAM TECHNOLOGY PRIVATE LIMITED. The arbitration proceedings 
                shall be conducted in English and the seat of arbitration shall be in New Delhi, India.
              </Typography>
              <Typography variant="body1">
                The decision of the arbitrator shall be final and binding on both parties. The costs of arbitration shall be borne equally by 
                both parties unless otherwise directed by the arbitrator.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center' }}>
                <GavelIcon sx={{ mr: 1 }} /> Termination
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" paragraph>
                We may terminate or suspend your access to RockkPay immediately, without prior notice or liability, for any reason whatsoever, 
                including, without limitation, if you breach these Terms.
              </Typography>
              <Typography variant="body1" paragraph>
                Upon termination, your right to use the Services will immediately cease. If you wish to terminate your account, you may simply 
                discontinue using the Services or contact our customer support to request account deletion.
              </Typography>
              <Typography variant="body1">
                All provisions of the Terms which by their nature should survive termination shall survive termination, including, without 
                limitation, ownership provisions, warranty disclaimers, indemnity, and limitations of liability.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center' }}>
                <GavelIcon sx={{ mr: 1 }} /> Governing Law
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" paragraph>
                These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law 
                principles.
              </Typography>
              <Typography variant="body1">
                You agree to submit to the exclusive jurisdiction of the courts located in New Delhi, India for the resolution of any disputes 
                arising out of or relating to these Terms or the RockkPay Services.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Box>

        {/* Contact Information */}
        <Card sx={{ mb: 4, bgcolor: '#f5f5f5' }}>
          <CardHeader title="Contact Information" />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle1" gutterBottom>
                  <strong>Address:</strong>
                </Typography>
                <Typography variant="body2" paragraph>
                PAYSTREAM TECHNOLOGY PRIVATE LIMITED<br />
                Unit No.355, Plot No 4,Rohini Sector-14,<br/>NEW DELHI,Delhi,110085
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle1" gutterBottom>
                  <strong>Customer Support:</strong>
                </Typography>
                <Typography variant="body2" paragraph>
                  Email: support@rockkpay.com<br />
                  
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* Acceptance */}
        <Box textAlign="center">
          <Typography variant="body1" paragraph>
            By using RockkPay, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
          </Typography>
        </Box>
      </Paper>
    </Container>
       
        </>
  );
};

export default RockkpayTandC;